module.exports = __webpack_public_path__ + "img/warning-grey.7eb6757c.svg";